import { render, staticRenderFns } from "./reset-pw.vue?vue&type=template&id=64da3150&scoped=true&lang=pug&"
import script from "./reset-pw.vue?vue&type=script&lang=js&"
export * from "./reset-pw.vue?vue&type=script&lang=js&"
import style0 from "../access.scss?vue&type=style&index=0&id=64da3150&lang=scss&scoped=true&"
import style1 from "./reset-pw.vue?vue&type=style&index=1&id=64da3150&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64da3150",
  null
  
)

export default component.exports